import { gConsts } from './gConsts';
import { router  } from '../router/router'
//import { store   } from '../store/store';
import axios from 'axios';
import Victor from 'victor';
import _ from 'lodash';

import { toothUtils } from '../features/tooth/lib/toothUtils';

// =========================================================================================
// Funcoes globais

export const utils = {
    generateRandomId() {
        return Math.random().toString(36).substring(2, 10);
    },
    searchMatches(text, searchText) {

        const normalizeString = (str) => (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
        return normalizeString(text).includes(normalizeString(searchText));
    },
    /**
     * 
     * @param {Document} document 
     * @returns Boolean
     */
    userIsFocusedOnInput(document) {
        const activeElement = document.activeElement;
        return (
            activeElement &&
            (activeElement.tagName.toLowerCase() === 'input' ||
            activeElement.tagName.toLowerCase() === 'textarea' ||
            activeElement.tagName.toLowerCase() === 'select' || 
            (activeElement.tagName.toLowerCase() === 'div' && activeElement.getAttribute('contenteditable') === 'true'))
        );
    },
    objHasProp(obj, prop) { return (prop in obj) },
    objHasSomeProp(obj, props) { props.some(prop => (prop in obj)); },

    // -----------------------------------------------------------------

    isDOMElemOrChild: function(elem, parent) {
        return ((elem == parent) || this.isChildNode(elem, parent));
    },
    
    // -----------------------------------------------------------------

    getBoundingRect: function(pts) {
        if (!pts || pts.length === 0) {
            return { x: 0, y: 0, width: 0, height: 0 };
        }
      
        let minX = pts[0].x;
        let maxX = pts[0].x;
        let minY = pts[0].y;
        let maxY = pts[0].y;
      
        pts.forEach(pt => {
            if (pt.x < minX) minX = pt.x;
            if (pt.x > maxX) maxX = pt.x;
            if (pt.y < minY) minY = pt.y;
            if (pt.y > maxY) maxY = pt.y;
        });
      
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    },    
    
    getCombinedBoundingRect(elements) {
        if (!elements || elements.length === 0) {
            return { x: 0, y: 0, width: 0, height: 0 };
        }

        const edges = elements.reduce((acc, elem) => {
            const rect = elem.getBoundingClientRect();
            return {
                left: Math.min(acc.left, rect.left),
                top: Math.min(acc.top, rect.top),
                right: Math.max(acc.right, rect.right),
                bottom: Math.max(acc.bottom, rect.bottom)
            };
        }, { left: Infinity, top: Infinity, right: -Infinity, bottom: -Infinity });

        return {
            x: edges.left,
            y: edges.top,
            width: edges.right - edges.left,
            height: edges.bottom - edges.top
        };
    },

    // -----------------------------------------------------------------
    
    isDOMChildNode: function(elem, parent) {
        var isChild  = false;
        var currParent = elem;
        
        if (elem == null) {
            return false;
        }
        
        currParent = elem.parentNode;
        while (currParent != null) {
            if (currParent == parent) {
                isChild = true;
                break;
            }
            currParent = currParent.parentNode;
        }
    
        return isChild;
    },

    // -----------------------------------------------------------------

    pixelToMm(size, dpi) { return size * dpi / 25.4; },

    // -----------------------------------------------------------------

    /* 
        Circle/Ray Intersection (very well explained article)
        ref: https://bluebill.net/circle_ray_intersection.html
    */

    // -----------------------------------------------------------------

    vPerp_vAB(vAB) { 
        return Victor(-vAB.y, vAB.x);
    },

    /* Acha a projecao de P no segmento/vetor vAB:
         Factor < 0 => projP_vAB estah antes do segmento AB (mais prox de pA)
         Factor > 1 => projP_vAB estah depois do segmento AB (mais prox de pB) 
         0 <= Factor <= 1 => projP_vAB estah dentro do segmento AB */
    projP_vAB(pP, pA, vAB) {
        var factor, 
            vAP, proj_vAP_vAB, projP_vAB;

        /* 
            pP - ponto qq
            pA - 1o ponto do segmento AB
            vAB - segmento AB
            vAP - segmento AP
            proj_vAP_vAB - projecão de vAP em vAB 
                => vAB . vAP / vAB . vAB * vAB
            ref: https://en.wikipedia.org/wiki/Vector_projection
                 https://www.youtube.com/watch?v=GnvYEbaSBoY 
        */
        vAP          = pP.clone().subtract(pA);
        factor       = vAB.clone().dot(vAP)/vAB.clone().dot(vAB);
        proj_vAP_vAB = vAB.clone().multiply(Victor(factor, factor));
        projP_vAB    = pA.clone().add(proj_vAP_vAB);

        return { proj : projP_vAB, factor : factor }
    },

    /* 
        Calcula distancia de pP ao segmento de reta vAB
        OBS: se projP_vAB nao estiver sobre o segmento de reta vAB, a distancia = min(distP_A, distP_B)
    */
    distP_vAB(pP, pA, pB) {
        var projP_vAB, dist,
            vAB = pB.clone().subtract(pA);

        projP_vAB = utils.projP_vAB(pP, pA, vAB);
        if (projP_vAB.factor < 0) {
            dist = pP.distance(pA);             // projP_vAB estah antes do segmento AB (mais prox de pA)
        } else if (projP_vAB.factor > 1) {
            dist = pP.distance(pB);             // projP_vAB estah depois do segmento AB (mais prox de pB) 
        } else {
            dist = pP.distance(projP_vAB.proj);  // projP_vAB estah dentro do segmento AB
        }

        return dist;
    },

    // -----------------------------------------------------------------

    isIn_nearToolPath(pM, tool, maxDist) {
        let pA, pB, duration, dist, distA, distB,
            target, 
            targetIdx = -1,
            pts = tool.coords.pts,
            isInObj = { isInDist : -1, isInTool : null, target : '', targetIdx : -1 },
            minDist = Infinity,
            start = Date.now();

        if (pts.length > 1) {
            for (let i = 1; i < pts.length; i++) {
                pA = Victor.fromObject(pts[i-1]);
                pB = Victor.fromObject(pts[i  ]);
                dist = utils.distP_vAB(pM, pA, pB);
                
                if (dist < minDist) {
                    minDist = dist;

                    distA = pM.distance(pA);
                    distB = pM.distance(pB);
                    if (Math.min(distA, distB) < maxDist) {
                        target = 'h'
                        targetIdx = (distA < distB) ? i-1 : i;
                    } else {
                        target = 'body'
                    }
                }      
            }
        } else {
            minDist = pM.distance(Victor.fromObject(pts[0]));
            target = 'body';
        }

        duration = Date.now() - start;
    //    console.log('utils.isIn_nearToolPath duration (ms): ' + duration + ' / pts.length: ' + pts.length);

        if (minDist <= maxDist) {
            isInObj = { 
                isInDist  : minDist, 
                isInTool  : tool, 
                target    : target,
                targetIdx : targetIdx
            }
        }
        return isInObj;
    },
    
    // -----------------------------------------------------------------

    isIn_tool(document, evt, matchTools, matchTool) {
        var tool_svgElem, toolId, svgElems_matchTool,
            re, reMatch, 
            isInTool, target, 
            targetIdx = -1,
            isInObj = { isInDist : -1, isInTool : null, target : '', targetIdx : -1 },
            svgElemsUnderMouse = document.elementsFromPoint(evt.clientX, evt.clientY).filter(elem => {
                return (elem instanceof SVGGraphicsElement) && 
                       (elem.style.opacity != '0'         ) &&
                       (elem.id.startsWith('tool_')       )
            });

        if (svgElemsUnderMouse.length > 0) {            
            // Se um toolId especifico foi passado soh serve se ele (ou algum de seus componentes) estiver debaixo do mouse
            if (matchTool) {
                svgElems_matchTool = svgElemsUnderMouse.filter(elem => elem.id.indexOf(matchTool.id) != -1);
                if (svgElems_matchTool.length > 0) {
                    tool_svgElem = svgElems_matchTool[0];
                }
            } else {
                tool_svgElem = svgElemsUnderMouse[0];               // Senão, o 1o tool_svgElem valido serve
            }

            if (tool_svgElem) {                                     // Se deu match (especifico ou generico)
                re = /(tool_(\w+)\[(\d+)\])(?:-((\w+)(?:\[(\d+)\])?))?/;
                reMatch = re.exec(tool_svgElem.id);                 // ex: tool_reta[12]-h[1] => 1: tool_reta[12], 2: reta, 3: 12, 4: h[1], 5: h, 6: 1                

                toolId = reMatch[1];
                isInTool = utils.findTool(matchTools, toolId);      // Tool associada ao svgElem encontrado
                if (isInTool) {
                    target = reMatch[5];
                    if (target == 'h') {
                        if (isInTool.type != gConsts.tool.attrib.types.PONTO) {
                            targetIdx = parseInt(reMatch[6], 10);
                        } else {
                            target = 'body'
                        }
                    }
                    isInObj = { 
                        isInDist  : 0, 
                        isInTool  : isInTool, 
                        target    : target,
                        targetIdx : targetIdx };        
                }
            }
        }

        return isInObj;
    },

    // -----------------------------------------------------------------

    findDente(document, position, dentes, activeDente) {
        var denteSvg, denteId, dentesSvgUnderMouse, 
            dentesIds = [],
            dente = null;

            dentes.forEach(dente => dentesIds.push(dente.id));
            dentesSvgUnderMouse = document.elementsFromPoint(position.x, position.y).filter(elem => (
                (elem instanceof SVGPathElement) && dentesIds.includes(elem.id.match(/[^-]*/)[0])
            ));

        if (dentesSvgUnderMouse.length > 0) {            
            if (activeDente && (dentesSvgUnderMouse.filter(denteSvg => denteSvg.id.indexOf(activeDente.id) != -1).length > 0)) {
                dente = activeDente;
            } else {
                denteSvg = dentesSvgUnderMouse[0];
                denteId  = denteSvg.id.match(/[^-]*/)[0];
                dente = utils.findTool(dentes, denteId);
            }
        }
        return dente;
    },

    /**
     * Encontra os tools mais próximos de uma posição
     * @description Retorna os tools mais próximos da posição
     * @param {Array<Object>} tools 
     * @param {{x: number, y: number}} position 
     * @param {number} maxDistance 
     * @returns {Array<{tool: Object, isInObj: Object}>}
     */
    findCloseToolsByPosition(tools, position, maxDistance) {
        var positionVector = Victor.fromObject(position);

        // console.log("positionVector: ", positionVector);
        // console.log("maxDistance: ", maxDistance);
        // console.log("tools: ", tools);

        return tools
            .map(tool => {
                const isInObj = utils.isIn_nearToolPath(positionVector, tool, maxDistance);
                return {
                    tool,
                    isInObj,
                }
            })
            .filter(item => ['body', 'h'].includes(item.isInObj.target))
            .sort((a, b) => a.isInObj.isInDist - b.isInObj.isInDist);
    },

    /**
     * Encontra o tool mais próximo de uma posição
     * @description Retorna o tool mais próximo da posição
     * @param {Array<Object>} tools 
     * @param {{x: number, y: number}} position 
     * @returns {{tool: Object, distance: number} | null}
     */
    findClosestToolByPosition(tools, position) {
        if (tools.length == 0) {
            return null;
        }
        var positionVector = Victor.fromObject(position);

        // console.log("positionVector: ", positionVector);
        // console.log("maxDistance: ", maxDistance);
        // console.log("tools: ", tools);

        return tools
            .map(tool => {
                const isInObj = utils.isIn_nearToolPath(positionVector, tool, Infinity);
                return {
                    tool,
                    isInObj,
                }
            })
            .filter(item => ['body', 'h'].includes(item.isInObj.target))
            .sort((a, b) => a.isInObj.isInDist - b.isInObj.isInDist)
            .map(item => ({
                tool: item.tool,
                distance: item.isInObj.isInDist
            }))
            .at(0);
    },

    /**
     * Encontra os tools mais próximos de um tool específico
     * @description Retorna os tools mais próximos do tool de referência
     * @param {Array<Object>} tools 
     * @param {Object} referenceTool 
     * @param {number} maxDistance 
     * @returns {Array<Object>}
     */
    findCloseToolsFromTool(tools, referenceTool, maxDistance) {
        // Por enquanto, só uso para pontos então pego o último ponto.
        const position = referenceTool.coords.pts[referenceTool.coords.pts.length - 1];
        const closeTools = utils.findCloseToolsByPosition(tools, position, maxDistance);
        return closeTools.map(item => item.tool);
    },

    /**
     * Encontra os dentes mais próximos de uma posição
     * @description Retorna os dentes mais próximos da posição
     * @param {Array<Object>} denteTools 
     * @param {{x: number, y: number}} position 
     * @param {number} maxDistance 
     * @returns {Array<Object>}
     */
    findCloseDenteToolsFromPosition(denteTools, position, maxDistance) {
        let closeDentes = utils.findCloseToolsByPosition(denteTools, position, maxDistance);

        if (closeDentes.length > 0) {
            const closestDente = closeDentes.sort((a, b) => a.isInObj.isInDist - b.isInObj.isInDist)[0];
            // Limito os dentes da mesma arcada/posicao
            const closestDenteDetails = toothUtils.getToothDetailsByLabelId(closestDente.tool.label.id);
            closeDentes = closeDentes.filter(dente => {
                const denteDetails = toothUtils.getToothDetailsByLabelId(dente.tool.label.id);
                return denteDetails.posicao == closestDenteDetails.posicao;
            });
        }
        return closeDentes.map(item => item.tool);
    },

    findToolElementByLabelIdAndToolType(document, tools, labelId, toolType) {
        const tool = tools.find(tool => tool.label.id == labelId && tool.attrib.type == toolType);
        if (!tool) 
            return null;
        return utils.findToolElementById(document, tool.id);
    },
    
    findToolElementById(document, toolId) {
        return document.querySelector(`g[id="${toolId}"]`);
    },
    
    // -----------------------------------------------------------------

    findLocations(document, evt, locations) {
        var location, locationsSvgUnderMouse, locationId, 
            activeLocations = [],
            locationStr = '',
            locationIds = [];
        
        locations.forEach(location => locationIds.push(location.id));
        locationsSvgUnderMouse = document.elementsFromPoint(evt.clientX, evt.clientY).filter(elem => (
            (elem instanceof SVGPathElement) && locationIds.includes(elem.id.match(/[^-]*/)[0])
        ));    

        if (locationsSvgUnderMouse.length > 0) {
            activeLocations = [];
            locationsSvgUnderMouse.forEach(locationSvg => {
                locationId = locationSvg.id.match(/[^-]*/)[0];
                location = utils.findTool(locations, locationId);
                activeLocations.push(location);                
            })
        }
        return activeLocations;
    },

    findInternalLocations(document, evt, locations) {
        var location, locationsSvgUnderMouse, locationId, 
            activeLocations = [],
            locationStr = '',
            locationIds = [];
        
        locations.forEach(location => locationIds.push(location.id));
        locationsSvgUnderMouse = document.elementsFromPoint(evt.clientX, evt.clientY).filter(elem => (
            (elem instanceof SVGPathElement) && locationIds.includes(elem.id.match(/[^-]*/)[0])
        ));    

        if (locationsSvgUnderMouse.length > 0) {
            activeLocations = [];
            locationsSvgUnderMouse.forEach(locationSvg => {
                // console.log('locationSvg.id', locationSvg.id)
                const layer = locationSvg.parentElement.parentElement.parentElement.getAttribute('data-layer');
                if (layer == gConsts.layer.locations.TEETH_INTERNAL) {
                    locationId = locationSvg.id.match(/[^-]*/)[0];
                    location = utils.findTool(locations, locationId);
                    // console.log('findInternalLocations.locationId', locationId);
                    activeLocations.push(location);                
                }
            })
        }
        return activeLocations;
    },

    // -----------------------------------------------------------------

    getCentroid(vertices) {
        let area = 0, cx = 0, cy = 0;
        const n = vertices.length;
    
        for (let i = 0; i < n; i++) {
            const { x: x1, y: y1 } = vertices[i];
            const { x: x2, y: y2 } = vertices[(i + 1) % n]; // Next vertex or the first vertex
    
            const a = x1 * y2 - x2 * y1;
            area += a;
            cx += (x1 + x2) * a;
            cy += (y1 + y2) * a;
        }
    
        area = area / 2;
        cx = cx / (6 * area);
        cy = cy / (6 * area);
    
        return { x: cx, y: cy };
    },

    // -----------------------------------------------------------------

    // Função antiga, não é usada mais ... 
    isIn_nearSvgPath(pM, svgElem, maxDist) {
        const pathLength = svgElem.getTotalLength();
        const numSamples = Math.ceil(pathLength / (maxDist * 2));
        let duration, dist, samplePoint,
            minDist = Infinity,
            nearestPoint = null,
            start = Date.now();
      
        for (let i = 0; i <= numSamples; i++) {
            samplePoint = svgElem.getPointAtLength((i / numSamples) * pathLength);
            dist = pM.distance(Victor.fromObject(samplePoint));
      
            if (dist < minDist) {
                minDist = dist;
                nearestPoint = samplePoint;
            }      
        }

        duration = Date.now() - start;
//        console.log('utils.isIn_svgPath duration (ms): ' + duration + ' / numSamples: ' + numSamples);

        return (minDist <= maxDist) ? minDist : -1;
    },   

    // -----------------------------------------------------------------

    findDenteByLabel(dentes, label) { return dentes.find(dente => dente.label.text == label) },
    findTool(tools, toolId) { return tools.find(tool => (tool.id == toolId)); },
    findToolByLabelId(tools, labelId) { return tools.find(tool => tool.label.id == labelId) },
    findToolIndex(tools, toolId) {
        var foundIndex = -1;
        tools.some(function (tool, index) { foundIndex = index; return tool.id == toolId; });
        if (!foundIndex) {
            console.log(`Warning: didn't find tool index : ${toolId}`);
        }
        return foundIndex;
    },
    findToolCMP(vueRoot, toolId) {
        return vueRoot.$children[0].$refs[toolId];
    },

    // -----------------------------------------------------------------

    numToolPts(toolType) {
        var numPts = 2;

        switch (toolType) {
            case gConsts.tool.attrib.types.PONTO         : numPts =  1; break;
            case gConsts.tool.attrib.types.RETANGULO_INC : numPts =  4; break;
            case gConsts.tool.attrib.types.PATH          : numPts = -1; break;
            case gConsts.tool.attrib.types.CURVA         : numPts = -1; break;
        }

        return numPts;
    },

    // -----------------------------------------------------------------

    getButtonToolType(button) {
        var toolType = gConsts.tool.attrib.types.NO_TOOL;

        switch (button) {
            case gConsts.ui.toolbar.buttons.PONTO         : toolType = gConsts.tool.attrib.types.PONTO        ; break;
            case gConsts.ui.toolbar.buttons.RETA          : toolType = gConsts.tool.attrib.types.RETA         ; break;
            case gConsts.ui.toolbar.buttons.RETANGULO     : toolType = gConsts.tool.attrib.types.RETANGULO    ; break;
            case gConsts.ui.toolbar.buttons.CIRCULO       : toolType = gConsts.tool.attrib.types.CIRCULO      ; break;
            case gConsts.ui.toolbar.buttons.RETANGULO_INC : toolType = gConsts.tool.attrib.types.RETANGULO_INC; break;
            case gConsts.ui.toolbar.buttons.PATH          : toolType = gConsts.tool.attrib.types.PATH         ; break;
            case gConsts.ui.toolbar.buttons.CURVA         : toolType = gConsts.tool.attrib.types.CURVA        ; break;
            case gConsts.ui.toolbar.buttons.DEL_TOOL      : toolType = gConsts.tool.attrib.types.DEL_TOOL     ; break;
            case gConsts.ui.toolbar.buttons.IMG_LABEL     : toolType = gConsts.tool.attrib.types.IMG_LABEL    ; break;
        }

        return toolType;
    },

    // -----------------------------------------------------------------

    jobColor(state) {
        var color = '#FFFFFF';

        switch (state) {
            case gConsts.job.states.EMPTY     : color = gConsts.job.colors.EMPTY;     break;
            case gConsts.job.states.PARTIAL   : color = gConsts.job.colors.PARTIAL;   break;
            case gConsts.job.states.DOUBT     : color = gConsts.job.colors.DOUBT;     break;
            case gConsts.job.states.DIVERGENT : color = gConsts.job.colors.DIVERGENT; break;
            case gConsts.job.states.DISCARDED : color = gConsts.job.colors.DISCARDED; break;
            case gConsts.job.states.CONFIRMED : color = gConsts.job.colors.CONFIRMED; break;
        }

        return color
    },

    labelColor(label, usedLabels) {
        return usedLabels.includes(label) ? gConsts.label.colors.USED : gConsts.label.colors.UNUSED;
    },

    // -----------------------------------------------------------------

    localStorage_getItem(key, defVal) {
        var lStorageVal = window.localStorage.getItem(key);

        lStorageVal = (lStorageVal == 'undefined' ? 'null' : lStorageVal);        
        lStorageVal = JSON.parse(lStorageVal);
        return (lStorageVal != null) ? lStorageVal : defVal;
    },

    localStorage_setItem(key, val) {
        localStorage.setItem(key, JSON.stringify(val));
    },

    // -----------------------------------------------------------------

    async saveImage(url, data, ret) {
        let response = ''

        try {
            response = await axios.post(url, data)
            if (response.data.status == 503) {
                localStorage.removeItem('auth')
                //redireciona para o login
                router.push({
                    path: '/login',
                    query: { nextUrl: ret }
                })
                return false;
            } else {
                return true;
            }

        } catch (error) {
            return false;
        }


    },

    // -----------------------------------------------------------------

    stepDentes(tools) {
        var stepDentes = {};

        tools.forEach(tool => {
            if (!utils.objHasProp(stepDentes, tool.label.id)) {
                stepDentes[tool.label.id] = [];
            }
            if (tool.dente != '') {
                stepDentes[tool.label.id].push(tool.dente);
            }            
        });

        return stepDentes;
    },

    // -----------------------------------------------------------------

    areMapsEqual(map1, map2) {
        // Check if both are null or undefined
        if (map1 == null && map2 == null) return true;

        // Check if only one is null or undefined
        if (map1 == null || map2 == null) return false;

        // Check if both are Map instances
        if (!(map1 instanceof Map) || !(map2 instanceof Map)) return false;        

        // Check if sizes are the same
        if (map1.size !== map2.size) return false;
      
        // Check each key-value pair
        for (const [key, value] of map1) {
            if (!map2.has(key) || map2.get(key) !== value) {
                return false;
            }
        }
      
        // If all checks pass, the maps are equal
        return true;
    },
      
    // -----------------------------------------------------------------

    getExternalLocationsList(locationIds) {
        return locationIds
    },

    getInternalLocationsList(locationIds) {
        return {
            faces : locationIds,
            regions : locationIds,
        }
    },

    // -----------------------------------------------------------------

}